<script setup lang="ts">
import { getCsatSurveyResponse, parseCastItem } from './utils';
import StarIcon from './StarIcon.vue';
// @ts-ignore
import { messageTimestamp } from 'shared/helpers/timeHelper';

import type { ICsatData } from './utils';

const props = defineProps<{ data: ICsatData }>();

const { data } = props ?? {};

const csatSurveyResponse = getCsatSurveyResponse(data);

const { feedback_message, rating } = csatSurveyResponse ?? {};

const { messages, feedback, isRtl } = parseCastItem(feedback_message) ?? {};

const { rateTitle, comments } = messages?.[0] ?? {};

const _rateTitle = rateTitle ? `“${rateTitle}”` : '';
// 判断是否为简单评价
const isSimpleRate = !_rateTitle && !comments?.length && !feedback;

const createdAt =
  data?.contentAttributes?.external_created_at || data?.created_at;
</script>
<template>
  <div v-if="rating" class="card-csat-wrapper" :dir="isRtl ? 'rtl' : 'ltr'">
    <div class="csat-rate-container">
      <ul class="csat-rate">
        <li
          v-for="index in 5"
          class="csat-rate-item"
          :class="{ active: index <= rating }"
        >
          <StarIcon />
        </li>
      </ul>
      <div v-if="isSimpleRate">
        <div v-if="_rateTitle" class="rate-comments-wrapper csat-rate-title">
          {{ _rateTitle }}
        </div>
      </div>
      <div class="rate-comments-wrapper" v-else>
        <div class="csat-rate-title" v-if="rateTitle">{{ _rateTitle }}</div>
        <div class="csat-comment-container" v-if="comments?.length">
          <div
            class="csat-comment-item"
            v-for="{ code, icon, comments } in comments"
            :key="code"
            :class="{ 'is-good': code === 'good' }"
          >
            <div v-if="icon" class="csat-comment-item-icon">{{ icon }}</div>
            <div v-if="comments?.length" class="csat-comment-item-list">
              <div v-for="{ code, content } in comments" :key="code">
                {{ content }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="csat-feedback" v-if="feedback">{{ feedback }}</div>
      <div v-if="createdAt" class="card-date">
        {{ messageTimestamp(createdAt, 'LLL d, h:mm a') }}
      </div>
    </div>
  </div>
</template>
<style lang="scss"></style>
<style lang="scss" scoped>
.card-csat-wrapper {
  flex: 1 1 100%;
  max-width: unset !important;
}

.csat-rate-container {
  margin: 0 auto;
  width: 392px;
  border: 1px solid #e9e9e9;
  border-radius: 10px;
  padding: 16px 12px;
  background-color: #fff;
  font-size: 14px;
  color: #000;
  text-align: left;
}

.csat-rate-container:has(.csat-comment-container) {
  width: 447px;
}

.csat-rate {
  list-style: none;
  display: flex;
  justify-content: space-between;

  .csat-rate-item {
    color: #e5e5e5;
  }

  .csat-rate-item.active {
    color: #ffb623;
  }
}

.csat-rate-title {
  text-align: center;
  line-height: 18px;
}

.rate-comments-wrapper {
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;

  &::before {
    content: '';
    height: 1px;
    background-color: #e3e3e3;
    display: block;
  }
}

.rate-comments-wrapper:has(.csat-comment-container) {
  margin-inline: 25.5px;
  gap: 8px;
}

.rate-comments-wrapper:has(~ .csat-feedback) {
  margin-bottom: 12px;
}

.csat-comment-container {
  display: flex;
  justify-content: center;
  padding-inline: 33.5px;

  .csat-comment-item-icon {
    margin-bottom: 10px;
    font-size: 17px;
    line-height: 17px;
    text-align: center;
  }

  .csat-comment-item-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
    line-height: 15px;
    color: #949494;
    font-size: 12px;
  }

  .csat-comment-item.is-good .csat-comment-item-list {
    color: #e79a00;
  }
}

.csat-comment-container:has(> :nth-child(2)) {
  justify-content: space-between;

  .csat-comment-item {
    max-width: 50%;
  }
}

.csat-feedback {
  min-height: 40px;
  border-radius: 10px;
  background-color: #f2f2f2;
  color: rgba($color: #000, $alpha: 0.4);
  font-size: 13px;
  line-height: 16px;
  padding: 12px 14px;
}

.card-date {
  margin-top: 8px;
  font-size: 0.625rem;
  color: #b0b3b8;
}
</style>
